module.exports = __webpack_public_path__ + "img/chrome14.33a8acf2.png";